import { render, staticRenderFns } from "./ReportPatient.vue?vue&type=template&id=542d653b&scoped=true"
import script from "./ReportPatient.vue?vue&type=script&lang=js"
export * from "./ReportPatient.vue?vue&type=script&lang=js"
import style0 from "./ReportPatient.vue?vue&type=style&index=0&id=542d653b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d653b",
  null
  
)

export default component.exports